export default __webpack_public_path__ + "static/media/project-threekingdom.65f12cb4.png";